import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function loginByQr(qrToken) {
  const { data } = await axios.post(routes.loginByQr, {
    qr_token: qrToken,
  }, AXIOS_DEFAULT_CONFIG);

  return data;
}
